export default {
  title: 'Disponibilidades de Reserva',
};
